import { LogLevel } from "@azure/msal-browser";

export const clientHostname = 'https://traxftlstage.tql.com';

export const environment = {
  production: false,
  development: true,
  logApiCalls: false,
  calendarApiServerUrl: 'https://lmservicesextstage.tql.com/calendar/api',
  omassPortalClientUrl: 'https://omassportalstage.tql.com',
  traxFtlApiServerUrl: 'https://lmservicesextstage.tql.com/traxftl/api',
  traxApiServerUrl: 'https://traxapistage.tql.com/api',
  // traxClientUrl: 'https://traxstage.tql.com',
  traxClientUrl: 'https://trax2stage.tql.com',
  traxLtlClientUrl: 'https://traxltlstage.tql.com',
  TervisTumblerId: 138149,
  msalConfigB2C: {
    tenantId: '8f6280b2-fa15-45c5-ae42-2a19f39781bc',
    clientId: '80e0d74e-31d3-4c0d-8ed7-34e1d757478d',
    postLogoutRedirectUri: 'https://trax2stage.tql.com',
    navigateToLoginRequestUrl: true,
    authority: 'https://tqlidentitystage.b2clogin.com/tqlidentitystage.onmicrosoft.com/b2c_1a_signup_signin_passwordreset',
    knownAuthorities: ['https://tqlidentitystage.b2clogin.com'],
    redirectUri: clientHostname + '/authcallback',
    scopes: [
      "https://tqlidentitystage.onmicrosoft.com/services_combined/TraxWebApplicationLayer.DefaultUserPermission ",
      "https://tqlidentitystage.onmicrosoft.com/services_combined/TraxFTLExperienceAPI.DefaultUserPermission ",
      "https://tqlidentitystage.onmicrosoft.com/services_combined/Customers.DefaultUserPermission ",
      "https://tqlidentitystage.onmicrosoft.com/services_combined/Email.DefaultUserPermission ",
      "https://tqlidentitystage.onmicrosoft.com/services_combined/Users.DefaultUserPermission " ,
    ],
    loggingEnabled: true,
    logLevel: LogLevel.Verbose
  },
  trimbleMaps: {
    apiKey: '61F9C1422C769C42A5128CF14E3BD6E0'
  }
}
